import type { TraceEvent } from "../core/types";

interface TraceTimelineProps {
  events: readonly TraceEvent[];
}

export function TraceTimeline({ events }: TraceTimelineProps) {
  return (
    <ol className="trace-list" aria-label="Agent execution trace">
      {events.map((event) => (
        <li className="trace-event" key={`${event.sequence}-${event.label}`}>
          <div className="trace-rail" aria-hidden="true">
            <span className={`trace-dot status-${event.status}`} />
          </div>
          <div className="trace-body">
            <div className="trace-heading">
              <span className="trace-sequence">
                {String(event.sequence).padStart(2, "0")}
              </span>
              <span className="trace-stage">{event.stage}</span>
              <span className={`status-pill status-${event.status}`}>
                {event.status}
              </span>
            </div>
            <p>{event.label}</p>
            {event.data ? (
              <dl className="trace-data">
                {Object.entries(event.data).map(([key, value]) => (
                  <div key={key}>
                    <dt>{key}</dt>
                    <dd>
                      {Array.isArray(value)
                        ? value.join(", ")
                        : String(value)}
                    </dd>
                  </div>
                ))}
              </dl>
            ) : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
